<div class="service-billing-setup-title-container">
	<div>
		<h3 class="header-text header-margin-bottom" i18n="@@billingContract-serviceBillingSetup">Service Billing Setup</h3>
		<h4 class="header-sub-text" i18n="@@billingContract-enterDetailsForNewBillingCustomer">
			Enter details for a new billing customer
		</h4>
	</div>
	<div>
		@if (
			userAction === 'viewing' && billingContract.status !== 'manuallyEnded' && billingContract.status !== 'completed'
		) {
			<button
				data-automation-id="billing-edit-contract-button"
				class="primary-small-button small-button-width-115-pixels"
				i18n="@@billingContract-editButton"
				(click)="onEditClick()"
			>
				Edit
			</button>
		}

		@if (userAction === 'editing') {
			<button
				data-automation-id="billing-edit-contract-cancel-button"
				class="secondary-small-button small-button-width-115-pixels button-margin-right"
				i18n="@@billingContract-cancelButton"
				(click)="useViewingMode()"
			>
				Cancel
			</button>
		}
		@if (userAction === 'editing') {
			<button
				data-automation-id="billing-edit-contract-end-billing-button"
				class="warning-small-button small-button-width-115-pixels button-margin-right"
				i18n="@@billingContract-endBillingButton"
				(click)="onEndBillingClick()"
			>
				End Billing
			</button>
		}
		@if (userAction === 'editing') {
			<button
				data-automation-id="billing-edit-contract-save-changes-button"
				class="small-button-width-115-pixels"
				i18n="@@billingContract-saveChangesButton"
				(click)="onSaveChangesClick()"
				[ngClass]="{ 'primary-small-button': isFormValid(), 'primary-small-button-disabled': !isFormValid() }"
			>
				Save Changes
			</button>
		}
	</div>
</div>
<mat-divider></mat-divider>
<div class="service-billing-setup-grid">
	<div class="company-name-container">
		<h4 class="service-billing-setup-label">{{ filterLabels.companyName }}</h4>
		<p class="service-billing-setup-label-value">{{ billingContract.company.name }}</p>
	</div>
	<div class="site-id-container">
		<h4 class="service-billing-setup-label">{{ filterLabels.netsuiteCustomerInternalId }}</h4>
		<p class="service-billing-setup-label-value">{{ billingContract.netsuiteCustomerInternalId }}</p>
	</div>
	<div></div>
	<div class="contract-name-container">
		<h4 class="service-billing-setup-label">{{ filterLabels.contractName }}</h4>
		<p class="service-billing-setup-label-value">{{ billingContract.contractName }}</p>
	</div>
	<div class="contact-id-container">
		<h4 class="service-billing-setup-label">{{ filterLabels.contractId }}</h4>
		<p class="service-billing-setup-label-value">{{ billingContract.contractId }}</p>
	</div>
	<div class="status-container">
		@if (userAction !== 'reviewing' && billingContract.status) {
			<div>
				<h4 class="service-billing-setup-label">{{ filterLabels.status }}</h4>
				<app-billing-status [status]="billingContract.status"></app-billing-status>
			</div>
		}
	</div>
	<div class="unit-of-measure-container">
		<h4 class="service-billing-setup-label">{{ filterLabels.unitOfMeasure }}</h4>
		<p class="service-billing-setup-label-value">
			{{ findObjectByKey(unitsOfMeasureOptions, billingContract.unitOfMeassureTypeId).value }}
		</p>
	</div>
	<div class="currency-type-container">
		<h4 class="service-billing-setup-label">{{ filterLabels.currencyType }}</h4>
		<p class="service-billing-setup-label-value">
			{{ findObjectByKey(currencyTypeOptions, billingContract.currencyTypeId).value }}
		</p>
	</div>
	<div class="unit-price-container">
		<h4 class="service-billing-setup-label">{{ filterLabels.unitPrice }}</h4>
		<p class="service-billing-setup-label-value">{{ billingContract.unitPrice }}</p>
	</div>
	<div class="billing-start-date-container">
		<h4 class="service-billing-setup-label">{{ filterLabels.billingStartDate }}</h4>
		@if (userAction === 'editing' && billingContract.status === 'upcoming') {
			<div>
				<mat-form-field
					subscriptSizing="dynamic"
					appearance="outline"
					class="thin-outline-input-field thin-outline-input-field-no-label billing-setup-column width-70-percent"
				>
					<input
						matInput
						[formControl]="billingStartDate"
						[matDatepicker]="billingStartDateDatepicker"
						[matDatepickerFilter]="billingDateOrFutureDateFilter"
						data-automation-id="start-datepicker-input"
					/>
					<mat-datepicker-toggle
						matSuffix
						[for]="billingStartDateDatepicker"
						data-automation-id="start-datepicker-toggle"
					>
						<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #billingStartDateDatepicker data-automation-id="start-datepicker"></mat-datepicker>
				</mat-form-field>
			</div>
		}
		@if (userAction !== 'editing' || billingContract.status !== 'upcoming') {
			<p class="service-billing-setup-label-value">
				{{ billingContract.billingStartDate | billingStartDateFilter }}
			</p>
		}
	</div>
	<div class="billing-trigger-container">
		<h4 class="service-billing-setup-label">{{ filterLabels.billingTrigger }}</h4>
		<p class="service-billing-setup-label-value">
			{{ findObjectByKey(billingTriggerOptions, billingContract.billingTriggerTypeId).value }}
		</p>
	</div>
	<div class="duration-container">
		<h4 class="service-billing-setup-label">{{ filterLabels.durationInMonths }}</h4>
		<p class="service-billing-setup-label-value">{{ billingContract.duration }}</p>
	</div>
	@if (billingContract.annualIncreasePercent) {
		<div class="annual-inc-container">
			<h4 class="service-billing-setup-label">{{ filterLabels.annualIncrease }}</h4>
			<p class="service-billing-setup-label-value">{{ billingContract.annualIncreasePercent }}%</p>
		</div>
	}
	<div class="device-lease-container">
		<h4 class="service-billing-setup-label">{{ filterLabels.deviceLease }}</h4>
		<p class="service-billing-setup-label-value">
			{{ billingContract.areDevicesLeased ? filterLabels.yes : filterLabels.no }}
		</p>
	</div>
	<div></div>
	@if (!billingContract.annualIncreasePercent) {
		<div></div>
	}
	<div class="billing-end-date-container">
		<h4 class="service-billing-setup-label">{{ filterLabels.billingEndDate }}</h4>
		@if (userAction === 'editing') {
			<div>
				<mat-form-field
					subscriptSizing="dynamic"
					appearance="outline"
					class="thin-outline-input-field billing-setup-column width-70-percent"
				>
					<mat-select
						disableOptionCentering
						panelClass="thin-outline-select-panel"
						[formControl]="billingEndDate"
						data-automation-id="end-date-picker"
					>
						@for (option of billingEndDateOptions; track option) {
							<mat-option [value]="option.key" [attr.data-automation-id]="'end-date-' + option.key">
								{{ option.valueTitle + ' ' + (option.valueTitleSmallerText ?? '') }}
							</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
		}
		@if (userAction !== 'editing') {
			<p class="service-billing-setup-label-value">
				{{
					findObjectByKey(billingEndDateOptions, billingContract.isMonthlyAutoRenewed).valueTitle +
						' ' +
						(findObjectByKey(billingEndDateOptions, billingContract.isMonthlyAutoRenewed).valueTitleSmallerText ?? '')
				}}
			</p>
		}
	</div>
</div>
@if (billingContract.addOnBilling.length !== 0 || userAction === 'editing') {
	<div class="add-on-billing-container" [formGroup]="addOnBillingFormGroup">
		<div class="add-on-billing-header-container">
			<h3 class="header-text header-margin-bottom" i18n="@@billingContract-addOnBillingTitle">Add-On Billing</h3>
			@if (userAction === 'reviewing') {
				<h3
					class="header-text header-margin-bottom header-text-title-smaller-text"
					i18n="@@billingContract-addOnBillingTitleSmallerText"
				>
					(optional)
				</h3>
			}
		</div>
		<mat-divider></mat-divider>
		<div class="add-on-billing-container-grid slight-margin-top slight-margin-bottom">
			<h4 class="add-on-billing-grid-title" i18n="@@billingContract-addOnBillingDescription">Description</h4>
			<h4 class="add-on-billing-grid-title" i18n="@@billingContract-addOnBillingQuantity">Quantity</h4>
			<h4 class="add-on-billing-grid-title" i18n="@@billingContract-addOnBillingUnitPrice">Unit Price</h4>
			<h4 class="add-on-billing-grid-title" i18n="@@billingContract-addOnBillingMRCOrNRC">MRC / NRC</h4>
		</div>
		@for (
			item of billingContract.addOnBilling;
			track item.description + '|' + item.recurringChargeTypeId;
			let i = $index
		) {
			<div>
				<div class="add-on-billing-container-grid slight-margin-bottom">
					<p class="service-billing-setup-label-value">{{ item.description }}</p>
					<p class="service-billing-setup-label-value">{{ item.quantity }}</p>
					<p class="service-billing-setup-label-value">{{ item.unitPrice }}</p>
					<p class="service-billing-setup-label-value">
						{{ findObjectByKey(mrcOrNrcOptions, item.recurringChargeTypeId).value }}
					</p>
				</div>
			</div>
		}
		@if (userAction === 'editing') {
			<div>
				@for (item of getControls(); track item; let i = $index) {
					<div formArrayName="addOnBillingFormArray">
						<div [formGroupName]="i" class="add-on-billing-container-grid add-on-billing-container-form-group-grid">
							<mat-form-field
								subscriptSizing="dynamic"
								appearance="outline"
								class="thin-outline-input-field"
								[ngClass]="{
									'thin-outline-input-field-force-invalid-outline': !isValidControlForOnBillingFormGroup(
										item,
										'description'
									),
								}"
							>
								<input
									matInput
									formControlName="description"
									autocomplete="off"
									[attr.data-automation-id]="'add-on-billing-description-' + i + '-input'"
								/>
							</mat-form-field>
							<mat-form-field
								subscriptSizing="dynamic"
								appearance="outline"
								class="thin-outline-input-field"
								[ngClass]="{
									'thin-outline-input-field-force-invalid-outline': !isValidControlForOnBillingFormGroup(
										item,
										'quantity'
									),
								}"
							>
								<input
									matInput
									formControlName="quantity"
									autocomplete="off"
									(keypress)="isNumberKey($event)"
									[attr.data-automation-id]="'add-on-billing-quantity-' + i + '-input'"
								/>
							</mat-form-field>
							<mat-form-field
								subscriptSizing="dynamic"
								appearance="outline"
								class="thin-outline-input-field"
								[ngClass]="{
									'thin-outline-input-field-force-invalid-outline': !isValidControlForOnBillingFormGroup(
										item,
										'unitPrice'
									),
								}"
							>
								<input
									matInput
									formControlName="unitPrice"
									autocomplete="off"
									(keypress)="isNumberOrPeriodKey($event)"
									[attr.data-automation-id]="'add-on-billing-unit-price-' + i + '-input'"
								/>
							</mat-form-field>
							<mat-form-field
								subscriptSizing="dynamic"
								appearance="outline"
								class="thin-outline-input-field billing-setup-column"
								[ngClass]="{
									'thin-outline-input-field-force-invalid-outline': !isValidControlForOnBillingFormGroup(
										item,
										'recurringChargeTypeId'
									),
								}"
							>
								<mat-select
									disableOptionCentering
									formControlName="recurringChargeTypeId"
									panelClass="thin-outline-select-panel"
									[attr.data-automation-id]="'add-on-billing-mrcornrc-' + i + '-picker'"
								>
									<mat-label></mat-label>
									@for (option of mrcOrNrcOptions; track option) {
										<mat-option
											[value]="option.key"
											[attr.data-automation-id]="'add-on-billing-mrcornrc-' + option.value + '-option'"
										>
											{{ option.value }}
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
							<div class="trash-can-icon-container">
								<mat-icon
									svgIcon="sl-trash"
									class="trash-can-icon"
									(click)="removeAddOnBillingOption(i)"
									[attr.data-automation-id]="'remove-add-on-billing-' + i + '-button'"
								></mat-icon>
							</div>
						</div>
					</div>
				}
				<button
					mat-stroked-button
					(click)="addAddOnBillingOption($event)"
					class="incremental-button"
					data-automation-id="billing-edit-contract-incremental-button"
				>
					+
				</button>
			</div>
		}
	</div>
}
